import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M7.125 1h-3.5A2.625 2.625 0 0 0 1 3.625v8.75A2.625 2.625 0 0 0 3.625 15h8.75A2.625 2.625 0 0 0 15 12.375v-3.5M10.625 1H15m0 0v3.938M15 1 7.562 8.437"
    }, null, -1)
  ])))
}
export default { render: render }